
<template>
    <div class="actions-bar mt-md-8 mt-5 py-md-5 pt-4 pb-4">
        <div class="actions-bar-inner px-3">
 
                <slot name="actions"></slot>
       
        </div>
    </div>
</template>

<style>
    .actions-bar {
        border-top: solid 1px rgba(53,64,114, 0.2);
        
    }

    .actions-bar-inner{
        width: 100%;
        max-width: 1680px;
        margin: 0 auto;
    
    }

    

</style>